import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/appStore';
import { BrowserRouter } from 'react-router-dom';
import { JssProvider } from 'react-jss';
import ThemeProvider from './theming/ThemeProvider';
import SoundPlayer from './components/parcel-connect/SoundPlayer';
import { initializeGA4 } from './utils/ga4Analytics';
import config from './config';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

if (config?.GA4_MEASUREMENT_ID) {
  initializeGA4(config.GA4_MEASUREMENT_ID);
}


const launchApp = (Component: any) => {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <JssProvider>
            <ThemeProvider>
              <BrowserRouter>
                <SoundPlayer />
                <Component />
              </BrowserRouter>
            </ThemeProvider>
          </JssProvider>
        </I18nextProvider>
      </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
  );
};

const launchMain = () => launchApp(App);
launchMain();
